/**
 * Automation API клиент — настройки автоматизации (visit-stage → папка+задача).
 */
import { api } from "@/api/client";

export interface AutomationVisitConfig {
  create_folder: boolean;
  create_task: boolean;
  assignee_mode: "responsible" | "fixed";
  fixed_assignee_user_id: string | null;
  drive_topic_id: number | null;
  tasks_topic_id: number | null;
}

export const fetchVisitAutomationConfig = (): Promise<AutomationVisitConfig> =>
  api(`/api/automation/visit-config`);

export const patchVisitAutomationConfig = (payload: Partial<AutomationVisitConfig>): Promise<AutomationVisitConfig> =>
  api(`/api/automation/visit-config`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

export const triggerVisitAutomation = (): Promise<{ processed: number; folders_created: number; tasks_created: number; skipped: number; errors: number }> =>
  api(`/api/automation/visit-process-now`, { method: "POST" });
